/**
 * Текст ошибки от API для показа пользователю.
 *
 * Nest отдаёт строку в `message` (например, политика пароля) либо массив
 * строк (class-validator), либо объект с `error`. Монолит отдаёт `error`.
 */
export function resolveApiErrorMessage(error, fallback) {
    var _a;
    const data = error === null || error === void 0 ? void 0 : error.data;
    const message = (_a = data === null || data === void 0 ? void 0 : data.message) !== null && _a !== void 0 ? _a : data === null || data === void 0 ? void 0 : data.error;
    if (Array.isArray(message)) {
        return message.map((item) => String(item)).join(', ');
    }
    if (typeof message === 'string' && message.length) {
        return message;
    }
    return fallback;
}
export default resolveApiErrorMessage;
